//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { CustomFieldInputItem } from './CustomFieldInputItem';
import { WebsiteBlockType } from './Enums';

export abstract class WebsiteCustomFieldUpdateItem extends ItemBase {
    Name: string | null = null;
    OrderIndex: number = 0;
    Field: CustomFieldInputItem | null = null;
    abstract readonly WebsiteBlockType: WebsiteBlockType;

    static readonly ClassName: string = "WebsiteCustomFieldUpdateItem";
}
